import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";
import { imgs } from "@gw/theming";
import { useEnvContext } from "@gw/env-context";
import { AnchorButton } from "../AnchorButton";
var DeleteButton = function (_a) {
    var id = _a.id, onDelete = _a.onDelete;
    var imgsFolder = useEnvContext().imgsFolder;
    var handleDeleteButton = useCallback(function () {
        onDelete("" + id);
    }, [id, onDelete]);
    return (React.createElement(AnchorButton, { className: "accent", onClick: handleDeleteButton },
        React.createElement(ReactSVG, { className: "edit-icon", src: imgsFolder + "/" + imgs.icons.trash })));
};
export default DeleteButton;
//# sourceMappingURL=TableDeleteButton.js.map